import { Columns } from "@aviary";
import { BrandsListItem } from "@shared/components/CatalogSearch/BrandsListItem";
import type { Brand } from "@shared/components/CatalogSearch/CatalogSearch";
import type { BrandSplinter } from "@shared/data/queries/BrandsQuery";

interface Props {
  brands: BrandSplinter[];
  onBrandClick: (brand: Brand) => void;
  activeBrands: Brand[];
}

const CatalogBrands = ({ brands, onBrandClick, activeBrands }: Props) => {
  const isBrandActive = (id: string): boolean =>
    activeBrands.some(activeBrand => activeBrand.id === id);

  const renderBrands = () => {
    return brands?.map(brand => (
      <BrandsListItem
        brand={brand}
        key={brand.name}
        onClick={() => onBrandClick(brand)}
        isActive={isBrandActive(brand.id)}
      />
    ));
  };

  return (
    <Columns isMultiline data-testid="catalog-brands">
      {renderBrands()}
    </Columns>
  );
};

export { CatalogBrands };
